<template>
  <component
    :is="tag"
    :href="model.url || null"
    :class="{
      [activeClass]: model.isActive,
      [model.cssClass]: model.cssClass
    }"
    v-bind="model.attributes"
  >
    <slot />
    <span>{{ model.text }}</span>
  </component>
</template>

<script>
import { computed } from 'vue'

export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    emptyUrlTag: {
      type: String,
      default: null
    },
    activeClass: {
      type: String,
      default: 'active'
    }
  },
  setup(props) {
    const tag = computed(() => {
      const emptyUrlTag = props.emptyUrlTag || props.model.emptyUrlTag
      return props.model.url || !emptyUrlTag ? 'a' : emptyUrlTag
    })
    return {
      tag
    }
  }
}
</script>
